/* 🤖 this file was generated by svg-to-ts */
export const siriusXCircle: {
  name: 'x_circle';
  data: string;
} = {
  name: 'x_circle',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path d="M14.53 9.47a.75.75 0 0 1 0 1.06L13.06 12l1.47 1.47a.75.75 0 1 1-1.06 1.06L12 13.06l-1.47 1.47a.75.75 0 1 1-1.06-1.06L10.94 12l-1.47-1.47a.75.75 0 1 1 1.06-1.06L12 10.94l1.47-1.47a.75.75 0 0 1 1.06 0Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M4.25 12a7.75 7.75 0 1 1 15.5 0 7.75 7.75 0 0 1-15.5 0ZM12 5.75a6.25 6.25 0 1 0 0 12.5 6.25 6.25 0 0 0 0-12.5Z" fill="currentColor"/></svg>`
};
